module.exports = __webpack_public_path__ + "img/jardin6.b35338a4.jpg";